import "./RatingsTable.css";
import { useTranslation } from "react-i18next";

const RatingsTableHeader = ({ courseRating, slopeRating, totalPar }) => {
  const { t } = useTranslation();

  return (
    <table className="glfr-ratings-table">
      <thead>
        <tr className="glfr-ratings-header-row">
          <th className="glfr-ratings-header">{t("course_rating")}</th>
          <th className="glfr-ratings-header">{t("slope_rating")}</th>
          <th className="glfr-ratings-header">{t("total_par")}</th>
        </tr>
      </thead>
      <tbody>
        <tr className="glfr-ratings-row">
          <td className="glfr-ratings-cell">{courseRating}</td>
          <td className="glfr-ratings-cell">{slopeRating}</td>
          <td className="glfr-ratings-cell">{totalPar}</td>
        </tr>
      </tbody>
    </table>
  );
};

export default RatingsTableHeader;
